const en = {
    biography: {
        topline: 'Topline',
        currentRoles: 'Current roles',
        earlyLifeAndEducation: 'Early life and education',
        career: 'Career',
        personalLife: 'Personal life',
        controversies: 'Controversies',
        policies: 'Policies',
        notes: 'Notes',
        sanctions: 'Sanctions',
        goToCompany: 'Go to company',
        seeAlso: 'See also',
    },
    clientDashboardPage: {
        lastVisitedPages: 'Last visited pages',
        releases: 'Releases',
        closeUpdatesModule: 'Close updates module',
    },
    company: {
        revenue: 'Revenue:',
        employees: 'Employees:',
        incorporated: 'Incorporated:',
        revenueValue: '{{value}} revenue',
        employeesValue: '{{value}} employees',
        establishedValue: 'Est. {{value}}',
    },
    connectionsPage: {
        tabMenuLabel: 'Connections',
        titleCompany: 'Company',
        titleNetwork: 'Network',
        titleIndividual: 'Individual',
        holdings: {
            guo: 'GUO (Global Ultimate Owner)',
            bo: 'BO (Beneficial Owner)',
            oub: 'OUB (Other Ultimate Beneficiary)',
            address: 'Address',
            totalEmployees: 'Total number of employees',
            numberOfSubsidiaries: 'Number of subsidiaries',
            legalForm: 'Legal form',
            incorporationDate: 'Date of incorporation',
            tradeDescription: 'Trade description',
            sector: 'Sector',
            people: 'Departments & roles',
            totalAssets: 'Total assets',
            footerButton: 'Network and related individuals',
            sectors: 'Sectors',
            biography: 'Biography',
            relatedCompanies: 'Related companies',
            relatedIndividuals: 'Related individuals',
            relatedArticles: 'Related articles',
            politicalAffiliation: 'Political affiliation',
            companyPage: 'Company page',
            relatedIndividualsPage: 'Related individuals',
            revenue: 'Revenue',
            noOrganizationDataText:
                'There is no organization chart available for this company',
            noOrganizationDataLabel: 'No organization data available',
            noIndividualsText:
                'There are no related individuals for this company',
            noIndividualsLabel: 'No related individuals',
            noIndividualsTextAll:
                'There are no related individuals for this country',
            loadingIndividuals: 'Loading individuals for this country…',
        },
    },
    connectionsV2Page: {
        searchTitle: 'Search company or individual',
        searchPlaceholder: 'Search company or individual',
        clearSearch: 'Clear search',
        allCountries: 'All countries',
        companies: 'Companies',
        individuals: 'Individuals',
        filterCategory: 'Category',
        filterRevenue: 'Revenue',
        filterEmployees: 'Number of employees',
        filterOwner: 'Global ultimate owner',
        filterAffiliation: 'Political affiliation',
        filterSector: 'Sector',
        filterCompany: 'Company',
        noCompaniesLabel: 'No companies found',
        noIndividualsLabel: 'No individuals found',
        zeroStateHint: 'Adjust your filter settings or start a new search.',
        filterRole: 'Role',
    },
    connectionsCompanyPage: {
        tabMenuLabel: 'Company tabs',
        titleOverview: 'Company overview',
        titleNetwork: 'Network',
        networkLastUpdated: 'Latest updated: {{date}}',
        titleIndividuals: 'Individuals',
        chartLoading: 'Almost there! Finalizing your data view…',
        chartErrorLabel: 'Organization data could not be loaded',
        chartErrorText:
            'Something went wrong while fetching the data. Please try again later.',
        guo: 'GUO (Global Ultimate Owner)',
        oub: 'OUB (Other Ultimate Beneficiary)',
        legalForm: 'Legal form',
        address: 'Address',
        website: 'Website',
        websites: 'Websites',
        incorporated: 'Date of incorporation',
        tradeDescription: 'Trade description',
        nace: 'NACE Rev. 2 Core Code',
        operatingRevenue: 'Operating revenue',
        profitMargin: 'Profit margin',
        totalAssets: 'Total assets',
        employees: 'Total number of employees',
        unitRevenue: 'mUSD',
        unitPeople: 'people',
        revenueChart: 'Operating revenue (turnover)',
        revenueSeriesName: 'Revenue',
        axisYear: 'Year',
        axisRevenue: 'm USD',
        departments: 'Departements and roles',
        searchPeople: 'Search person profiles',
        filterPolitics: 'Political affiliation',
        filterSectors: 'Sectors',
    },
    connectionsIndividualPage: {
        nameAndTitle: 'Name and Title',
        politicalAffiliation: 'Political Affiliation',
        sectors: 'Sectors',
        biography: 'Biography',
        affiliations: 'Affiliations',
        relatedCompanies: 'Related companies',
        relatedIndividuals: 'Related individuals',
        relatedArticles: 'Related articles',
        lastUpdated: 'Latest updated: {{date}}',
    },
    numberSuffixes: {
        thousand: 'thousand',
        million: 'million',
        billion: 'billion',
        trillion: 'trillion',
        quadrillion: 'quadrillion',
    },
    formDropZone: {
        dropItems: 'Drag and drop your file/s here or',
        chooseFile: 'choose file',
        acceptedFormats: 'Accepted formats: PDF, JPG, PNG, DOCX, XLSX, CSV',
        maxFileSize: 'Max size: 15MB',
        delete: 'Delete file',
        fileTooLarge: 'exceeds the 15MB size limit',
        fileInvalidType: 'has an unsupported file type',
        fileRejected: 'was rejected',
    },
    general: {
        added: 'Added',
        backToConnections: 'Back to connections',
        errorFetchingData: 'Unable to load data',
        errorNoSeriesData: 'No data returned for the given query',
        errorDataReqFailed: 'Data request failed',
        read: 'Read',
        close: 'Close',
        and: 'and',
        logout: 'Log out',
        contact: 'Contact',
        address: 'Address',
        clientLogin: 'Client Login',
        links: 'Links',
        updated: 'Updated',
        showDetails: 'Show details',
        noRequests: 'There are no completed requests for information yet',
        na: 'N/A',
        bookmark: 'Favorites',
        bookmarkPage: 'Add to favorites',
        bookmarkRemove: 'Remove from favorites',
        bookmarkAdded: 'Added to favorites',
        bookmarkRemoved: 'Removed from favorites',
        noBookmarks: 'You have no favorite pages saved.',
        noBookmarksText:
            'Add favorite pages by clicking the favorite button on each page.',
        seeFullProfile: 'View profile',
        sanctioned: 'Sanctioned',
        selectCountry: 'Select country',
        selectCompany: 'Select company',
        searchKeywords: 'Add search keyword',
        noSelectedCountryLabel: 'No country selected',
        noSelectedCountryText: 'Select a country to explore its networks',
        noSelectedCompanyLabel: 'No company selected',
        noSelectedCompanyText: 'Select a company to explore its networks',
        features: 'Features and actions',
        noResults: 'No results found',
    },
    homeFooter: {
        interested: 'Are you interested?',
        connect: 'Connect with us',
    },
    logOutConfirmationPage: {
        headline: 'Logging out...',
        preamble:
            '<p>You are being signed out. You will be redirected shortly.</p>',
    },
    map: {
        address: 'Address',
        boardOfDirectors: 'Board of directors',
        close: 'Close',
        departmentAndRoles: 'Department & roles',
        employees: 'Employees',
        employeesCount: '{{count}} ppl',
        employeesBranches: '{{count}} ppl',
        employeesDistributors: '{{count}} ppl',
        employeesMain: '{{count}} ppl',
        employeesSubsidiaries: '{{count}} ppl',
        guo: 'GUO (Global Ultimate Owner)',
        headOfOffice: 'Head of office',
        holdingsOverview: 'Companies overview',
        markertingAndAdvertising: 'Marketing & advertising',
        millionUsd: 'million USD',
        usd: 'USD',
        next: 'Next',
        numBranches: '{{count}} Branches',
        numDistributors: '{{count}} Distributors',
        numMain: '{{count}} Main',
        numSubsidiaries: '{{count}} Subsidiaries',
        previous: 'Previous',
        publicAndGovernmentAffairs: 'Public & government affairs',
        revenueCount: '{{count}} USD',
        revenueBranches: '{{count}} million USD',
        revenueDistributors: '{{count}} million USD',
        revenueMain: '{{count}} million USD',
        revenueSubsidiaries: '{{count}} million USD',
        seniorManagement: 'Senior management',
        sites: 'Sites',
        totalEmployees: 'Total number of employees',
        totalRevenue: 'Total revenue',
        totalSites: 'Total number of sites',
        locationCount: 'Item {{current}} out of {{total}}',
        tagText:
            'Note: Coordinates missing, location approximated to city center',
        tagTextCountry:
            'Note: Coordinates missing, location approximated to country center',
    },
    mapFilter: {
        mapButton: 'View holdings map',
        viewListButton: 'View company list',
        clearAllFilters: 'Clear all filters',
        clear: 'Clear',
        clearSelection: 'Clear selection',
        category: 'Category',
        done: 'Done',
        close: 'Close',
        filter: 'Filter',
        numberOfEmployees: 'Number of employees',
        revenue: 'Revenue',
        searchHoldings: 'Search holdings',
        typeOfLocations: 'Type of locations',
        globalUltimateOwner: 'Global Ultimate Owner',
        sector: 'Sector',
        politicalAffiliation: 'Political affiliation',
        company: 'Company',
    },
    mediaMonitorPage: {
        latest: 'Latest news',
        searchResults: 'Search results',
        closeArticle: 'Back to Media Monitor',
        mostRead: 'Most read',
        weFound: 'We found',
        articles: 'News articles matching your search',
        backToMonitor: 'Back to monitor',
        newsFeed: 'News feed',
    },
    mediaMonitorFilter: {
        searchKeywords: 'Add search keyword/s',
        search: 'Search',
        tags: 'Tags',
        authors: 'Authors',
        sources: 'Sources',
        entities: 'Product',
        countries: 'Country',
        topics: 'Themes & topics',
    },
    modalFileSubmissionForm: {
        title: 'Upload and share files',
        successMessage: 'Your files have been sent',
        uploadFiles: 'Upload file/s',
        cancel: 'Cancel',
        close: 'Close',
        submit: 'Send',
        submitNewRequest: 'Share file',
        descriptionField: {
            placeholder:
                'Optional. Please add a description or comment for the files shared.',
            label: 'Description or comments',
        },
    },
    nav: {
        showChildren: 'Show children',
    },
    notFoundPage: {
        label: 'Error 404 - Page not found',
        title: 'The page you are looking for could not be found',
        description:
            'Please use the navigation links below to find what you need:',
        links: {
            home: 'Home',
            homeDashboard: 'Home dashboard',
            toolbox: 'Toolbox',
            startPage: 'Start page',
        },
    },
    errorPage: {
        label: 'Error 500 - Internal server error',
        title: 'An internal server error occured while trying to access the page',
        description:
            'Please use the navigation links below to find what you need:',
        links: {
            home: 'Home',
            homeDashboard: 'Home dashboard',
            toolbox: 'Toolbox',
            startPage: 'Start page',
        },
    },
    reportItem: {
        reportBy: 'By',
        by: 'By',
        downloadPDF: 'Download as PDF',
        downloadFullReport: 'Download full report',
        downloadDataSet: 'Download data set',
        newReport: 'New report',
    },
    categoryHeader: {
        pin: 'Pin section',
        unpin: 'Unpin section',
        expand: 'Expand section',
        collapse: 'Collapse section',
        newReports: 'New reports available',
    },
    reportsPage: {
        reports: 'Reports',
        otherReports: 'Other reports',
        toArchive: 'View all reports',
        mediaMonitor: 'Media monitor',
    },
    reportArticlePage: {
        published: 'Published',
        updated: 'Updated',
        relatedFiles: 'Related files',
        tableOfContents: 'Table of contents',
        source: 'Source',
        sources: 'Sources',
        fullReport: 'Download full report',
        dataSet: 'Download data set',
        backToReports: 'Back to Reports',
        backToOverview: 'Back to overview',
        analysis: 'Analysis',
        estimatedDelivery: 'Estimated delivery: ',
        desiredDeliveryDate: 'Desired delivery date: ',
    },
    reportComments: {
        panelTitle: 'Comments',
        countLabel: 'Comments ({{count}})',
        close: 'Close comments',
        closeButton: 'Close',
        allComments: 'All comments',
        you: '(you)',
        formerUser: 'Former user',
        orphaned: 'Referenced text removed or changed',
        emptyTitle: 'No comments yet',
        emptyText: 'Select text in the report to comment on it.',
        addComment: 'Add comment',
        addCommentShortcut: 'Ctrl+Alt+M, or ⌘⌥M on a Mac',
        commentLabel: 'Write your comment',
        commentPlaceholder: 'Type here',
        commentHeading: 'Comment',
        post: 'Post comment',
        cancel: 'Cancel',
        postFailed: "Your comment couldn't be posted. Please try again.",
        delete: 'Delete comment',
        deleteButton: 'Delete',
        confirmDelete: 'Yes, delete comment',
        deleteFailed: "The comment couldn't be deleted. Please try again.",
    },
    archivePage: {
        filterCategories: 'Filter categories',
        weFound: 'We found',
        resultsMatching: 'results matching your search',
        clearAll: 'Clear all',
        noReports: 'No reports match your search',
        zeroStateHint: 'Adjust your filter settings or start a new search.',
    },
    reportsFilter: {
        searchKeywords: 'Add search keyword/s',
        search: 'Search',
        category: 'Category',
        tags: 'Theme or topic',
        authors: 'Author',
        country: 'Country or region',
    },
    relatedCard: {
        submittedBy: 'Submitted by',
        reportSubmittedBy: 'By',
        newsSubmittedBy: 'Submitted by',
    },
    downloadFileItem: {
        relatedFiles: 'Download{{fileType}}',
        previewPdf: 'Preview PDF',
    },
    supportForm: {
        inquirySent: 'Your inquiry has been sent',
        sendInquiry: 'Send inquiry',
        typeHere: 'Type here',
    },
    textBlock: {
        updated: 'Updated',
    },
    toolBoxPage: {
        viewAll: 'View all',
        latest: 'Latest news',
        connections: 'Connections',
        open: 'Open',
        noMatches: 'No matches found',
    },
    toolbar: {
        loggedInAs: 'Logged in as',
        connectedAccounts: 'Connected accounts',
        goToDashboard: 'Go to {{title}}',
        currentDashboard: '{{title}}, current account',
    },
    watchtowerPage: {
        flowmap: 'Flowmap',
        countries: 'Countries',
        close: 'Close',
        showFlowmapLayer: 'Flowmap',
        layers: 'Map layers',
        showFilters: 'Show filters',
        hideFilter: 'Hide filters',
        showOverview: 'Show overview',
        clearAll: 'Clear all',
        saveActiveFilters: 'Save active filters',
        filtersSaved: 'Filters saved',
    },
    watchtowerCountryPage: {
        btnHoldings: 'View companies',
        titleHoldings: 'Companies',
        titleTopCompanies: 'Top companies',
        titleIndustry: 'Industry',
        btnIndustry: 'View industry',
        titleEconomy: 'Economy',
        btnEconomy: 'View economy',
        titlePolitics: 'Politics',
        btnPolitics: 'View politics',
        titleOverview: 'Overview',
        titleHybridActivity: 'Hybrid activity',
        hybridActivityEmptyState:
            'There is no hybrid activity to display for this country yet.',
        hybridActivityLoadError:
            'Hybrid activity could not be loaded. This is a problem at our end, not an empty dataset.',
        hybridActivityNoLayers:
            'No hybrid activity layers are configured, so nothing can be drawn. Add them under Hybrid activity tab settings on the Watchtower page above this one.',
        hybridActivityUnclaimedLayers:
            'Not drawn, because no layer claims them: {{values}}. Add a layer for each, or leave them out on purpose.',
        hybridActivityBlankLayerValue: 'rows with no layer value',
        hybridActivityLayers: 'Layers',
        hybridActivityHoldingsLayer: 'Holdings',
        hybridActivityFilters: 'Filters',
        hybridActivityLastUpdated: 'Latest updated: {{date}}',
        hybridActivityDates: 'Date range',
        hybridActivityDateFrom: 'From',
        hybridActivityDateTo: 'To',
        hybridActivityDate: 'Date',
        hybridActivitySwitchToDate: 'Switch to date slider',
        hybridActivitySwitchToRange: 'Switch to date range',
        hybridActivityDatePicker: 'Choose from the calendar',
        hybridActivityCardSources: 'Sources',
        hybridActivityLogTitle: 'Incident log',
        hybridActivityLogEmpty: 'No incidents in the selected date range.',
        hybridActivityLogShowMore: 'Show more',
        hybridActivityLogStatus: 'Status',
        hybridActivityLogLocation: 'Location',
        hybridActivityLogSources: 'Sources',
        tabMenuLabel: 'Horizontal tab menu',
        relatedReports: 'Related reports',
        btnRelatedReports: 'Go to Reports',
        relatedNews: 'Related articles',
        btnRelatedNews: 'Go to News',
        news: 'News',
        report: 'Report',
    },
    yearPicker: {
        clear: 'Clear',
        selectDate: 'Select date',
        selectYear: 'Select year',
        year: 'Year: ',
    },
    legend: {
        title: 'Legend',
        controlingShareholder: 'Controlling shareholder',
        individual: 'An individual',
        beneficialOwner: 'Beneficial owner',
        corporateGroup: 'Corporate group',
        globalUltimateOwner: 'Global ultimate owner',
        sanctions: 'Sanctions',
        shellCompany: 'Shell company',
    },
    latestUpdates: {
        menuLabel: 'Latest updates',
    },
};

export default en;
